import React from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineLockClosed, HiOutlineUpload } from "react-icons/hi";
import FeatureCtaCard from "../../common/FeatureCtaCard";

const ESignatureCtaBlock: React.FC<{
  variant: "upload" | "upgrade";
  onPrimaryCta: () => void;
  onHelpClick?: () => void;
}> = ({ variant, onPrimaryCta, onHelpClick }) => {
  const { t } = useTranslation();

  const isUpgrade = variant === "upgrade";

  return (
    <FeatureCtaCard
      icon={
        isUpgrade ? (
          <HiOutlineLockClosed size={22} />
        ) : (
          <HiOutlineUpload size={22} />
        )
      }
      title={
        isUpgrade
          ? (t("esignature.cta.upgradeTitle") as string)
          : (t("esignature.cta.uploadTitle") as string)
      }
      body={
        isUpgrade
          ? (t("esignature.cta.upgradeBody") as string)
          : (t("esignature.cta.uploadBody") as string)
      }
      ctaLabel={
        isUpgrade
          ? (t("esignature.upsell.ctaLabel") as string)
          : (t("esignature.gettingStarted.primaryCta") as string)
      }
      ctaIcon={isUpgrade ? undefined : "upload"}
      onCta={onPrimaryCta}
      secondaryLabel={
        onHelpClick
          ? (t("esignature.gettingStarted.helpLink") as string)
          : undefined
      }
      onSecondary={onHelpClick}
    />
  );
};

export default ESignatureCtaBlock;
